module.exports = __webpack_public_path__ + "img/29.2d093c95.jpg";